import constants from '../../constants/app-constants';

const initialState = {
  requests: null
};

const Reward = (state = initialState , action) => {
  switch(action.type){
  case constants.admin.REWARD_NEW : return {...state , requests : action.payload};

  case constants.admin.REWARD_GET: {
    return {...state, reward: action.payload};
  }

  case constants.admin.REWARD_EDIT: {
    return {...state, rewardEdit: action.payload};
  }

  case constants.admin.REWARD_GET_ALL: {
    return {...state, rewardGetAll: action.payload};
  }

  default: return state;
  }
};

export default Reward;